import React, {useState} from "react";
import styles, {C} from "../styles";
import Modal from "./Modal";
import {apiForgotPassword, apiForgotPseudo} from "../api/auth";

export default function ForgotAccountModal({type, onClose}) {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const title = type === "pseudo" ? "Pseudo oublié" : "Mot de passe oublié";
    const actionLabel = type === "pseudo" ? "Envoyer mon pseudo" : "Envoyer le lien de réinitialisation";

    async function handleSubmit() {
        setMessage("");
        const data = type === "pseudo" ? await apiForgotPseudo(email) : await apiForgotPassword(email);
        setMessage(data.message || "Si ce compte existe, un email a été envoyé.");
    }

    return (
        <Modal title={title} onClose={onClose}>
            <p style={{fontSize: 13, color: C.textMuted, lineHeight: "18px"}}>
                Indiquez votre adresse professionnelle. Si vous ne recevez rien sous 10 minutes,
                pensez à vérifier vos spams. Vous pouvez aussi indiquer directement votre
                adresse de secours personnelle si vous l'avez déjà enregistrée dans votre profil.
            </p>
            <input value={email} onChange={e => setEmail(e.target.value)}
                   placeholder="Email professionnel ou adresse de secours" style={styles.input}/>
            <button onClick={handleSubmit} style={styles.primaryButton}>{actionLabel}</button>
            {message && <p style={{marginTop: 8, fontSize: 13, color: C.text}}>{message}</p>}
        </Modal>
    );
}
